import { requestGraphQL } from '../../../utils/request';
import { getHarvestYieldsWitSilageQuery} from '../../../queries/harvestYieldsQuery';

import { parseHarvestSeasons } from './selectors';
import { HarvestYieldsResponse } from '../../types/HarvestYieldsResponse';

import { HarvestYield } from '../../../types/HarvestYield';

interface HarvestSeasons {
  postHarvestYields: HarvestYield[];
}

export async function requestHarvestSeasons(fieldUuid: string): Promise<HarvestSeasons> {
  const response = (await requestGraphQL(getHarvestYieldsWitSilageQuery(fieldUuid, []), {
    version: '2',
  })) as HarvestYieldsResponse;

  return {
    postHarvestYields: parseHarvestSeasons(response.data.field),
  };
}
